export default defineNuxtPlugin({
  name: 'analytics',
  dependsOn: ['branch'],
  async setup() {
    const { isDev } = useRuntimeConfig().public;
    if (isDev) {
      console.info('Running in dev mode. Skipping analytics setup.');
      return;
    }
    const { setGtag, setYandexMetrica } = useAnalytics();
    setGtag();
    setYandexMetrica();
  }
});